export const presetSkillOptions = [
  "Babysitting",
  "Car Detailing",
  "Car Washing",
  "Cleaning",
  "Cosmetology",
  "Dog Walking",
  "Errands",
  "Lawn Care",
  "Moving Help",
  "Pet Sitting",
  "Photography",
  "Power Washing",
  "Pool Opening / Cleaning / Maintenance",
  "Social Media",
  "Sports Training",
  "Tech Help",
  "Tutoring",
  "Yard Work",
] as const;

export const maxProfileSkills = 15;
